<div class="salon-details-page">
  @if (isLoadingServices && !salonDetails) {
    <app-loader></app-loader>
  }

  <!-- =========================================================
       Breadcrumb
  ========================================================== -->

  <nav class="breadcrumb" aria-label="Breadcrumb">
    <a class="breadcrumb__home" href="/">
      <img [src]="assetUrl + 'icons/home-line.svg'" alt="" />
    </a>

    <span class="breadcrumb__divider">/</span>

    <a href="/customer/search">Salons</a>

    <span class="breadcrumb__divider">/</span>

    <span class="breadcrumb__current">
      {{ salonDetails?.name || "Salon details" }}
    </span>
  </nav>

  <!-- =========================================================
       Hero / gallery
  ========================================================== -->

  <section class="salon-hero">
    <div class="salon-hero__background" aria-hidden="true">
      <span class="hero-orb hero-orb--one"></span>
      <span class="hero-orb hero-orb--two"></span>
      <span class="hero-grid"></span>
    </div>

    <div class="salon-gallery">
      <div
        class="salon-gallery__main"
        [style.background-image]="'url(' + assetUrl + 'img/salon-details3.png)'"
      ></div>

      <div class="salon-gallery__side">
        <div
          class="salon-gallery__small"
          [style.background-image]="
            'url(' + assetUrl + 'img/salon-details2.png)'
          "
        ></div>

        <div
          class="salon-gallery__small salon-gallery__small--photos"
          [style.background-image]="
            'url(' + assetUrl + 'img/salon-details1.png)'
          "
        >
          <button
            type="button"
            class="photos-button"
            (click)="openGalleryModal()"
          >
            <img [src]="assetUrl + 'icons/image.svg'" alt="" />
            <span>See photos</span>
          </button>
        </div>
      </div>
    </div>

    <div class="salon-hero__summary">
      <div class="salon-hero__copy">
        <span class="hero-pill">
          <span class="hero-pill__dot"></span>
          Available to book
        </span>

        <h1>
          {{ salonDetails?.name }}
        </h1>

        <div class="salon-meta">
          <div class="salon-meta__item">
            <img [src]="assetUrl + 'icons/star-yellow.svg'" alt="" />

            <strong>4.7</strong>
            <span>124 reviews</span>
          </div>

          <span class="salon-meta__divider"></span>

          <div class="salon-meta__item">
            <img [src]="assetUrl + 'icons/place.svg'" alt="" />

            <span>
              {{ salonDetails?.city || "Local salon" }}
            </span>
          </div>

          <span class="salon-meta__divider"></span>

          <div class="salon-meta__item">
            <span class="price-rating">$$</span>
            <span class="price-rating price-rating--muted">$$</span>

            @if (servicePriceRange.maxPrice > 0) {
              <span>
                ${{ servicePriceRange.minPrice }} – ${{
                  servicePriceRange.maxPrice
                }}
              </span>
            }
          </div>
        </div>
      </div>

      <div class="salon-hero__action">
        <span>Ready when you are</span>

        <button type="button" class="primary-cta" (click)="scrollIntoView()">
          Book a service
          <span>→</span>
        </button>
      </div>
    </div>
  </section>

  <!-- =========================================================
       Main tabs/card
  ========================================================== -->

  <section class="salon-content">
    <glo-tabs [tabs]="tabs" [scrollingMode]="true" #GloTabsComponent>
      <!-- =====================================================
           OVERVIEW
      ====================================================== -->

      <ng-template gloTabContent="overview">
        <div class="tab-content overview-layout">
          <div class="overview-main">
            <section class="content-card introduction-card">
              <span class="section-kicker">About</span>

              <h2>Welcome to {{ salonDetails?.name }}</h2>

              <p class="intro-description">
                {{
                  salonDetails?.description ||
                    "Discover services, availability, and everything you need to plan your next visit."
                }}
              </p>

              <div *ngIf="servicesNames.length" class="service-tags">
                <glo-tag
                  *ngFor="
                    let service of servicesNames;
                    trackBy: trackServiceById
                  "
                  [text]="service"
                  [showIcon]="false"
                ></glo-tag>
              </div>
            </section>

            <section class="content-card location-card">
              <div class="section-heading">
                <div>
                  <span class="section-kicker"> Location </span>

                  <h2>Find your way</h2>
                </div>

                <div class="location-summary">
                  <img [src]="assetUrl + 'icons/marker-lg.svg'" alt="" />

                  <div>
                    <strong>
                      {{ salonDetails?.address }}
                    </strong>

                    <span>
                      {{ salonDetails?.city }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="map-shell">
                <glo-google-map
                  [center]="{
                    lat: salonDetails?.latitude || 0,
                    lng: salonDetails?.longitude || 0,
                  }"
                  [zoom]="14"
                  [markers]="[
                    {
                      lat: salonDetails?.latitude || 0,
                      lng: salonDetails?.longitude || 0,
                    },
                  ]"
                >
                </glo-google-map>
              </div>
            </section>
          </div>

          <aside class="overview-side">
            <div class="content-card quick-info-card">
              <span class="section-kicker"> At a glance </span>

              <h3>Salon details</h3>

              <div class="quick-info-list">
                <div class="quick-info-item">
                  <div class="quick-info-icon">
                    <img [src]="assetUrl + 'icons/marker-lg.svg'" alt="" />
                  </div>

                  <div>
                    <span>Location</span>

                    <strong>
                      {{ salonDetails?.city || "—" }}
                    </strong>

                    <small>
                      {{ salonDetails?.address || "" }}
                    </small>
                  </div>
                </div>

                <div class="quick-info-item">
                  <div class="quick-info-icon quick-info-icon--purple">
                    &#64;
                  </div>

                  <div>
                    <span>Email</span>

                    <strong>
                      {{ salonDetails?.email || "—" }}
                    </strong>
                  </div>
                </div>

                <div class="quick-info-item">
                  <div class="quick-info-icon quick-info-icon--dark">$</div>

                  <div>
                    <span>Typical service range</span>

                    <strong>
                      @if (servicePriceRange.maxPrice > 0) {
                        ${{ servicePriceRange.minPrice }} – ${{
                          servicePriceRange.maxPrice
                        }}
                      } @else {
                        View services
                      }
                    </strong>
                  </div>
                </div>
              </div>

              <button
                type="button"
                class="side-book-button"
                (click)="scrollIntoView()"
              >
                View services
                <span>→</span>
              </button>
            </div>
          </aside>
        </div>
      </ng-template>

      <!-- =====================================================
           SERVICES
      ====================================================== -->

      <ng-template gloTabContent="services">
        <div class="tab-content services-tab" #serviceTabContent>
          <div class="tab-heading">
            <div>
              <span class="section-kicker"> Services </span>

              <h2>Choose your next treatment.</h2>

              <p>
                Browse available services, compare pricing, and choose what you
                would like to book.
              </p>
            </div>

            <div class="service-count">
              <strong>{{ filteredServices.length }}</strong>
              <span>services</span>
            </div>
          </div>

          <div class="services-layout">
            <!-- Categories -->

            <aside class="service-categories">
              <span class="service-categories__title"> Categories </span>

              <button
                *ngFor="let category of serviceCategories"
                type="button"
                class="category-button"
                [class.category-button--active]="activeServicesTab === category"
                (click)="onTabChange(category)"
              >
                <span>{{ category }}</span>

                <span
                  *ngIf="activeServicesTab === category"
                  class="category-dot"
                ></span>
              </button>
            </aside>

            <!-- Services -->

            <div class="services-results">
              <div *ngIf="isLoadingServices" class="services-state">
                <div class="loading-spinner"></div>

                <strong>Loading services</strong>

                <span> Finding available services for this salon... </span>
              </div>

              <div
                *ngIf="servicesError"
                class="services-state services-state--error"
              >
                <strong>Unable to load services</strong>

                <span>
                  {{ servicesError }}
                </span>

                <button type="button" (click)="loadServices()">
                  Try again
                </button>
              </div>

              <ng-container *ngIf="!isLoadingServices && !servicesError">
                <div
                  *ngIf="filteredServices.length === 0"
                  class="services-state"
                >
                  <strong>No services found</strong>

                  <span>
                    There are no services available in this category right now.
                  </span>
                </div>

                <article
                  *ngFor="
                    let service of filteredServices;
                    trackBy: trackServiceById
                  "
                  class="service-card"
                >
                  <div class="service-card__main">
                    <div class="service-card__icon">✦</div>

                    <div class="service-card__copy">
                      <span class="service-card__eyebrow">
                        {{ activeServicesTab }}
                      </span>

                      <h3>
                        {{ service.name }}
                      </h3>

                      <p>
                        Professional service provided by
                        {{ salonDetails?.name }}.
                      </p>

                      <div class="service-card__meta">
                        <span> Flexible appointment duration </span>
                      </div>
                    </div>
                  </div>

                  <div class="service-card__booking">
                    <span class="service-price-label"> From </span>

                    <strong>
                      {{ formatPrice(service.price) }}
                    </strong>

                    <button
                      type="button"
                      class="service-book-button"
                      (click)="onAddService(service)"
                    >
                      Book
                      <span>+</span>
                    </button>
                  </div>
                </article>

                <div *ngIf="totalCount > pageSize" class="pagination">
                  <span>
                    Showing {{ services.length }} of {{ totalCount }} services
                  </span>

                  <div class="pagination__controls">
                    <button
                      type="button"
                      (click)="onPreviousPage()"
                      [disabled]="!hasPrevious"
                    >
                      ← Previous
                    </button>

                    <span>
                      {{ currentPage }}
                    </span>

                    <button
                      type="button"
                      (click)="onNextPage()"
                      [disabled]="!hasNext"
                    >
                      Next →
                    </button>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-template>

      <!-- =====================================================
           REVIEWS
      ====================================================== -->

      <ng-template gloTabContent="reviews">
        <div class="tab-content reviews-tab">
          <div class="tab-heading">
            <div>
              <span class="section-kicker"> Reviews </span>

              <h2>What customers are saying.</h2>

              <p>
                Read recent experiences from customers who have visited this
                salon.
              </p>
            </div>

            <div class="review-score">
              <strong>4.7</strong>

              <div>
                <span>★★★★★</span>
                <small>124 reviews</small>
              </div>
            </div>
          </div>

          <div *ngIf="salonReview.length > 0" class="reviews-grid">
            <article *ngFor="let review of salonReview" class="review-card">
              <div class="review-card__top">
                <div class="review-stars">
                  <span
                    *ngFor="let star of [1, 2, 3, 4, 5]"
                    [class.review-star--muted]="star > review.rating"
                  >
                    ★
                  </span>
                </div>

                <span class="verified-pill"> Verified visit </span>
              </div>

              <p class="review-copy">“{{ review.description }}”</p>

              <div class="review-customer">
                <img
                  [src]="
                    review.customer.profile_picture_url ||
                    assetUrl + 'img/avatar1.png'
                  "
                  alt=""
                />

                <div>
                  <strong>
                    {{ review.customer.full_name }}
                  </strong>

                  <span> gloget customer </span>
                </div>

                <img
                  class="verified-icon"
                  [src]="assetUrl + 'icons/verified.svg'"
                  alt="Verified"
                />
              </div>
            </article>
          </div>

          <div *ngIf="salonReview.length === 0" class="review-empty">
            <glo-empty mode="reviews"></glo-empty>
          </div>
        </div>
      </ng-template>
    </glo-tabs>
  </section>
</div>

<!-- =========================================================
     Appointment modal
========================================================== -->

@if (showAppointmentModal) {
  <app-service-appointment
    [showAppointmentModal]="showAppointmentModal"
    [selectedService]="selectedService"
    [salonServices]="services"
    [salonId]="salonId"
    (closeModal)="onCloseModal()"
    (appointmentBooked)="onAppointmentBooked($event)"
  >
  </app-service-appointment>
}
